/**
 * SECTION — MAIN BLOG (Carnet · La Promenade)
 *
 * Enhances the horizontal "fil":
 *  - vertical wheel scrolls the track horizontally, releasing to the page's
 *    vertical scroll at either end (so the footer stays reachable);
 *  - draws the sinuous SVG thread through the station centres;
 *  - keeps the rail pager index in sync and wires the ‹ › arrows.
 * Progressive enhancement: without JS the track scrolls horizontally natively
 * and the filters (native tag links) still work — only the drawn thread is lost.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function buildThread(section) {
    var track = section.querySelector('[data-blog-track]');
    var svg = section.querySelector('[data-blog-thread-svg]');
    var path = section.querySelector('[data-blog-thread]');
    if (!track || !svg || !path) return;

    var stations = track.querySelectorAll('.cp-station');
    if (!stations.length) { path.setAttribute('d', ''); return; }

    var H = track.clientHeight || 1;
    var W = track.scrollWidth || 1;
    var amp = 82;
    var pts = [[0, H / 2]];
    stations.forEach(function (st) {
      var cx = st.offsetLeft + st.offsetWidth / 2;
      pts.push([cx, H / 2 + (st.classList.contains('up') ? -amp : amp)]);
    });
    pts.push([W, H / 2]);

    var d = 'M ' + pts[0][0] + ' ' + pts[0][1];
    for (var i = 1; i < pts.length; i++) {
      var p0 = pts[i - 1], p1 = pts[i], cx = (p0[0] + p1[0]) / 2;
      d += ' C ' + cx + ' ' + p0[1] + ' ' + cx + ' ' + p1[1] + ' ' + p1[0] + ' ' + p1[1];
    }
    svg.setAttribute('width', W);
    svg.setAttribute('height', H);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    path.setAttribute('d', d);
  }

  function updateIndex(section) {
    var track = section.querySelector('[data-blog-track]');
    var ix = section.querySelector('[data-blog-index]');
    if (!track || !ix) return;
    var pw = track.clientWidth || 1;
    var pages = Math.max(1, Math.ceil((track.scrollWidth - 60) / pw));
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max > 0 ? track.scrollLeft / max : 0;
    var page = Math.round(ratio * (pages - 1)) + 1;
    ix.textContent = pad(page) + ' / ' + pad(pages);
  }

  function init() {
    document.querySelectorAll('[data-blog-promenade]').forEach(function (section) {
      var track = section.querySelector('[data-blog-track]');
      if (!track) return;

      var refresh = function () { buildThread(section); updateIndex(section); };

      // announces autoloaded stations to screen readers (aria-live region)
      var status = section.querySelector('[data-blog-status]');
      var announce = function () {
        if (!status) return;
        var tpl = status.getAttribute('data-status-template') || '%count%';
        status.textContent = tpl.replace('%count%', track.querySelectorAll('.cp-station').length);
      };

      track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var max = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= 0;
        var atEnd = track.scrollLeft >= max - 1;
        if ((e.deltaY > 0 && !atEnd) || (e.deltaY < 0 && !atStart)) {
          track.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });

      track.addEventListener('scroll', function () { updateIndex(section); }, { passive: true });

      var nudge = function (dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      };
      var prev = section.querySelector('[data-blog-prev]');
      var next = section.querySelector('[data-blog-next]');
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });

      // Infinite scroll. The [data-blog-more] link is a real <a href> (works
      // without JS); we intercept it — on approach via IntersectionObserver and
      // on click — to fetch the next page, append its stations, then swap in its
      // trailing element (the next "more" link, or the final .cp-fin).
      var loadingMore = false;
      var moreObserver = null;

      var observeMore = function () {
        var more = track.querySelector('[data-blog-more]');
        if (!more) { if (moreObserver) moreObserver.disconnect(); return; }
        if (!moreObserver) {
          moreObserver = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) loadMore();
          }, { root: track, rootMargin: '0px 600px 0px 0px' });
        }
        moreObserver.observe(more);
      };

      var loadMore = function () {
        var more = track.querySelector('[data-blog-more]');
        if (loadingMore || !more) return;
        loadingMore = true;
        if (moreObserver) moreObserver.disconnect();
        fetch(more.href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-blog-track]');
            if (src) {
              src.querySelectorAll('.cp-station').forEach(function (st) { track.insertBefore(st, more); });
              var trail = src.querySelector('[data-blog-more], .cp-fin');
              if (trail) { more.replaceWith(trail); } else { more.remove(); }
            }
            loadingMore = false;
            refresh();
            announce();
            observeMore();
          })
          .catch(function () { loadingMore = false; observeMore(); });
      };

      track.addEventListener('click', function (e) {
        var more = e.target.closest ? e.target.closest('[data-blog-more]') : null;
        if (more) { e.preventDefault(); loadMore(); }
      });

      observeMore();

      window.addEventListener('resize', refresh);
      window.addEventListener('load', refresh);
      setTimeout(refresh, 80);
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
